<template>
  <Notification :description="$t('plus_notification_hotel_offers')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0 tw:shrink-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="setupHotelOffer"
        >
          <span>{{ $t('hotel_offers_cta_post') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import Notification from './Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { useHotelOffers } from '../hotelOffers/useHotelOffers'
import { useRouter } from 'vue-router'

const router = useRouter()
const { openCreateOfferFromNotification } = useHotelOffers()
const setupHotelOffer = () => {
  if (router?.currentRoute.value?.name === 'hotel-offers') {
    openCreateOfferFromNotification()
  } else {
    router.push({ name: 'hotel-offers' })
  }
}
</script>
